<!--
名字：迦南小萝莉
控場套路：双刀/心佛/血海1招
主内功层数：唐门会意6
残阳/混元层数：75/75
阴脉：454
阳脉：220
錢包預算：60D
想學的原因：飞起来打鱼油
修炼后是否能立刻升级：能
额外想说的：我最萌
-->

<script>

export let data;
</script>

<div class="border-8 border-solid bg-gray-200 text-green-900 flex card" id={data.number}>
    <div class="flex-1">
        <a href="./assets/imgs/cards/{data.number}.jpg" target="_blank">
            <img src="./assets/imgs/cards/{data.number} (Small).jpg" alt="" class="rounded-xl"  />
        </a>
    </div>
    <div class="text-left flex-1">
        <div>编号：{data.number}</div>
        <div>名字：{data.name}</div>
        <div>控場套路：{data.taolu}</div>
        <div>主内功：{data.mainnei}</div>
        <div>残阳/混元/万兽：{data.subnei}</div>
        <div>阴脉：{data.yin}</div>
        <div>阳脉：{data.yang}</div>
        <div>錢包預算：{data.pocket}</div>
        <div>想學的原因：{data.reason}</div>
        <div>修炼后是否能立刻升级：{data.upgrade}</div>
        <div>额外想说的：{data.description}</div>
        <div>百晓生点评：{data.add}</div>
        <img src="./assets/imgs/cards/{data.number}.svg" width="500px" alt="" class="rounded-xl"/>
    </div>
</div>

<style>

    img{
        width: 352px;
    }
    .card{
        max-width: 56rem;
        justify-content:center;
        align-items:start;
        padding: 3px;
        margin : 3px;
    }

</style>